export const DragTypes = {
    Asset: 'asset',
    Package: 'package',
    Section: 'section',
    Placeholder: 'placeholder'
  }
  